module.exports = __webpack_public_path__ + "img/KG_gue.72623407.png";